import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementBlock as _createElementBlock, vShow as _vShow, isRef as _isRef, withDirectives as _withDirectives, resolveDirective as _resolveDirective, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cf3e904e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "api-goods-drawer-content" }
const _hoisted_2 = { class: "api-goods-drawer-tab-content" }
const _hoisted_3 = { style: {"max-width":"264px","font-size":"14px"} }
const _hoisted_4 = { class: "api-goods-drawer-search flex-center" }
const _hoisted_5 = {
  key: 0,
  class: "flex-center search-stock"
}
const _hoisted_6 = { class: "goods-content" }

import { t } from '@/plugins/i18n'
import Search from '../Search.vue'
import ProductList from '../ProductList.vue'
import Drawer from '@/components/common/Drawer.vue'
import { ref, computed, watch, onMounted } from 'vue'
import useShopProduct from './useProduct'
import { searchShopProduct, syncAllGoods, similarProductCode } from '@/apis/associated'
import { confirmApiUnbind } from '@/util/useConfirm'
import { useRequest } from '@/util/useLoading'
import { ElMessage } from 'element-plus'
import { isD2C, isEN, isJA, isKO } from '@/store'
import { isUrl } from '@/plugins/utils'
import { useStore } from 'vuex'
import { ShopType } from '@/common/const'
import { request } from '@/config/request/interceptors'
import { ShopPurchaseRespDTO } from '@/service/customer'
import { WarningFilled } from '@element-plus/icons-vue'


export default /*#__PURE__*/_defineComponent({
  props: ['thirdItemCode', 'add'],
  setup(__props, { expose }) {

const props = __props

const productType = ref('transparent')
const searchRef = ref()
const langType = ref('1')
const keyword = ref('')
const visible = ref(false)
const showProduct = ref(true)
const productCategoryFrontendId = ref('')
const priceRange = ref('')
const imgUrl = ref('')
const wareHouseType = ref('1')
const searchWareHouseType = ref('')
const quantity = ref(1)
const quantitySymbol = ref(1)
const close = () => {
  visible.value = false
}
const isJpPurchase = computed(() => store.getters.isJpPurchase)
// 多仓配置
const moreWarehouseConfig = computed<ShopPurchaseRespDTO>(() => store.getters.moreWareConfig)

const open = (key: string, lang: string, type?: string, url?: string) => {
  keyword.value = key
  langType.value = String(lang || (isJA() ? '1' : isKO() ? '3' : isEN() ? '4' : '2'))
  visible.value = true
  productType.value = type ?? 'transparent'
  imgUrl.value = url || ''
  if (moreWarehouseConfig.value?.allowMutiWareHouseDelivery) {
    wareHouseType.value = '1'
  } else {
    wareHouseType.value = moreWarehouseConfig.value?.deliveryType === 'ONLY_CN' ? '2' : '3'
  }
  resetList()
  if ((!key && !url) && productType.value === 'transparent') return
  search()
}
expose({
  open
})

const realProductType = computed(() => {
  // 存在特殊场景查询相似商品
  if (imgUrl.value) {
    return 'similar'
  }
  return productType.value
})
const store = useStore()
const isTiktok = computed(() => store.getters?.shopInfo?.customerShopPlatform === ShopType.TIKTOK && isD2C())
onMounted(() => {
  store.dispatch('route/changeMoreWareConfig')
})

const shopParams = computed(() => {
  return {
    keyword: keyword.value,
    langType: langType.value,
    productCategoryFrontendId: productCategoryFrontendId.value,
    priceRange: priceRange.value,
    thirdItemCode: props.thirdItemCode,
    url: imgUrl.value,
    quantity: quantity.value,
    quantitySymbol: quantitySymbol.value,
    wareHouseType: wareHouseType.value // tiktok店铺只查询日本仓
  }
})

// 查询获取店铺商品列表数据
const [
  shopProductLoading,
  shopProductPageData,
  shopProductList,
  shopProductTotal,
  shopProductListApi,
  resetList
] = useShopProduct(realProductType, shopParams)

const reset = () => {
  keyword.value = ''
  productCategoryFrontendId.value = ''
  priceRange.value = ''
  quantity.value = 1
  quantitySymbol.value = 1
  searchRef.value.resetFilter()
  shopProductListApi()
}
const search = (searchParams?: any) => {
  if (shopProductLoading.value) return
  if (keyword.value) {
    imgUrl.value = ''
  }
  // 市场购透明购搜索条件为空不请求
  if (['transparent', 'market'].includes(realProductType.value) && !keyword.value && !searchParams?.productCategoryFrontendId) {
    // 当搜索关键字为空时清空列表
    resetList()
    return
  }
  if (searchParams) {
    keyword.value = searchParams.keyword
    productCategoryFrontendId.value = searchParams.productCategoryFrontendId
    priceRange.value = searchParams.priceRange
  }
  searchWareHouseType.value = wareHouseType.value
  shopProductListApi()
}
const handleClick = (type:any) => {
  productType.value = type
  shopProductPageData.value.pageNum = 1
  shopProductLoading.value = false
  keyword.value = ''
  productCategoryFrontendId.value = ''
  priceRange.value = ''
  searchRef.value.resetFilter()
  imgUrl.value = ''
  quantity.value = 1
  quantitySymbol.value = 1
  search()
}

const selectRow = async (row: any) => {
  shopProductLoading.value = true
  // 选择商品
  // 图搜商品
  if (imgUrl.value) {
    // 先落库
    const { data, success } = await similarProductCode(row.id)
    if (success) {
      await props.add({
        ...row,
        id: data.productCode,
        productCode: data.productCode,
        productType: 1
      })
      shopProductLoading.value = false
      visible.value = false
    } else {
      shopProductLoading.value = false
    }
    return
  }
  const resData = await props.add(row)
  shopProductLoading.value = false
  if (!resData) return
  visible.value = false
}
watch(shopProductList, async (newValue) => {
  if (isUrl(keyword.value) && newValue.length === 1) {
    shopProductLoading.value = true
    const data = newValue[0]
    await props.add({
      ...data,
      id: data.productCode,
      productCode: data.productCode,
      productType: 1
    })
    shopProductLoading.value = false
    visible.value = false
  }
})

return (_ctx: any,_cache: any) => {
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_tooltip = _resolveComponent("el-tooltip")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(Drawer, {
    visible: visible.value,
    "onUpdate:visible": _cache[12] || (_cache[12] = ($event: any) => ((visible).value = $event)),
    onBeforeClose: close,
    onOk: close,
    title: _unref(t)('选择供货商品'),
    showBtn: false,
    size: "1000px",
    className: "api-goods-drawer-components"
  }, {
    default: _withCtx(() => [
      _withDirectives(_createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item", {active: productType.value === 'transparent'}]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (handleClick('transparent')))
          }, _toDisplayString(_unref(t)('透明购')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item", {active: productType.value === 'market'}]),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (handleClick('market')))
          }, _toDisplayString(_unref(t)('市场购')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item", {active: productType.value === 'oem'}]),
            onClick: _cache[2] || (_cache[2] = ($event: any) => (handleClick('oem')))
          }, _toDisplayString(_unref(t)('OEM')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item", {active: productType.value === 'combin'}]),
            onClick: _cache[3] || (_cache[3] = ($event: any) => (handleClick('combin')))
          }, _toDisplayString(_unref(t)('组合商品')), 3),
          _createElementVNode("div", {
            class: _normalizeClass(["tab-item", {active: productType.value === 'stock'}]),
            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleClick('stock')))
          }, [
            _createTextVNode(_toDisplayString(_unref(t)('库存商品')) + " ", 1),
            (_unref(isJpPurchase))
              ? (_openBlock(), _createBlock(_component_el_tooltip, {
                  key: 0,
                  effect: "light",
                  placement: "top",
                  "popper-class": "tool-tip-no-border"
                }, {
                  content: _withCtx(() => [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(t)('日本商品有限在此tab下搜索')), 1)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_el_icon, {
                      color: "#999",
                      class: "cursor-pt icon"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_unref(WarningFilled))
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ], 2),
          _createElementVNode("div", {
            class: "tab-item",
            onClick: _cache[5] || (_cache[5] = ($event: any) => (handleClick('collect')))
          }, _toDisplayString(_unref(t)('收藏商品')), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          (['stock'].includes(productType.value))
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createVNode(_component_el_select, {
                  modelValue: wareHouseType.value,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((wareHouseType).value = $event)),
                  style: { marginRight: '4px', maxWidth: '100px' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, {
                      value: "1",
                      label: _unref(t)('全部')
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      value: "2",
                      label: _unref(t)('中国仓')
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_option, {
                      value: "3",
                      label: _unref(t)('日本仓')
                    }, null, 8, ["label"])
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_el_input, {
                  modelValue: quantity.value,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((quantity).value = $event)),
                  style: {"margin-right":"4px","flex":"1","width":"300px"}
                }, {
                  prepend: _withCtx(() => [
                    _createVNode(_component_el_select, {
                      modelValue: quantitySymbol.value,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((quantitySymbol).value = $event)),
                      style: {"width":"80px"},
                      class: "prependSel"
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_option, {
                          label: '≥',
                          value: 1
                        }),
                        _createVNode(_component_el_option, {
                          label: '=',
                          value: 2
                        }),
                        _createVNode(_component_el_option, {
                          label: '≤',
                          value: 3
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true),
          _createVNode(Search, {
            placeholder: (productType.value === 'stock' && _unref(isJpPurchase)) ? _unref(t)('请输入商品名&sku编码') : ['transparent', 'market'].includes(productType.value) ? _unref(t)('请输入URL、商品名、THE CKB SKU') : _unref(t)('请输入商品名'),
            class: "search-platform",
            value: keyword.value,
            "onUpdate:value": _cache[10] || (_cache[10] = ($event: any) => ((keyword).value = $event)),
            onSearch: search,
            showFilter: ['transparent', 'market'].includes(productType.value),
            ref: (_value, _refs) => {
              _refs['searchRef'] = _value
              searchRef.value = _value
            }
          }, {
            prepend: _withCtx(() => [
              _createVNode(_component_el_select, {
                style: {"width":"130px"},
                modelValue: langType.value,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((langType).value = $event))
              }, {
                default: _withCtx(() => [
                  (_unref(isJA)())
                    ? (_openBlock(), _createBlock(_component_el_option, {
                        key: 0,
                        label: _unref(t)('日本语入力'),
                        value: "1"
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true),
                  (_unref(isEN)())
                    ? (_openBlock(), _createBlock(_component_el_option, {
                        key: 1,
                        label: "English",
                        value: "4"
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_option, {
                    label: _unref(t)('中国语入力'),
                    value: "2"
                  }, null, 8, ["label"]),
                  (_unref(isKO)())
                    ? (_openBlock(), _createBlock(_component_el_option, {
                        key: 2,
                        label: _unref(t)('韩语'),
                        value: "3"
                      }, null, 8, ["label"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["placeholder", "value", "showFilter"]),
          _createVNode(_component_el_button, {
            class: "reset-btn",
            onClick: reset
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_unref(t)('重置2')), 1)
            ]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_6, [
          _withDirectives(_createVNode(ProductList, {
            wareHouseType: searchWareHouseType.value,
            moreWarehouseConfig: _unref(moreWarehouseConfig),
            ref: (_value, _refs) => {
              _refs['productRef'] = _value
            },
            data: _unref(shopProductList),
            pageData: _unref(shopProductPageData),
            "onUpdate:pageData": _cache[11] || (_cache[11] = ($event: any) => (_isRef(shopProductPageData) ? (shopProductPageData).value = $event : null)),
            total: _unref(shopProductTotal),
            onRefresh: _unref(shopProductListApi),
            type: "platform",
            onSelectRow: selectRow
          }, null, 8, ["wareHouseType", "moreWarehouseConfig", "data", "pageData", "total", "onRefresh"]), [
            [_vShow, showProduct.value]
          ])
        ])
      ], 512), [
        [_directive_loading, _unref(shopProductLoading)]
      ])
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})